<div [hidden]="!isLoading" class="page-loader text-center">
  <div class="loader"></div>
</div>
<div class="hero search-hero">
  <core-search-form [autoFocus]="!hasSearchTerm()"></core-search-form>
</div>

<div class="search-page-content-wrapper">
  <div class="row">
    <div class="col-sm-12 search-results-content px-0">
      <div class="search-top">
        @if ((!hasResults() && hasSearchTerm()) || (hasResults() && introText)) {
          <div class="col-sm-12">
            @if (!hasResults() && hasSearchTerm() && search.isActive() && !isLoading) {
              <p [innerHTML]="noResultsText"></p>
            }
            @if (hasResults()) {
              <h3>
                <span [innerText]="'Results for' | translate"></span>:&nbsp;
                <span [innerText]="search.getQuery()"></span>
              </h3>
            }
          </div>
        }
      </div>

      @if (hasResults()) {
        <div class="search-results-container">
          @if (!hasPages()) {
            <p>No pages on this site match your search.</p>
          }
          @if (hasPages()) {
            <div class="pages-container">
              @for (result of pageResults; track 'page-' + $index) {
                <div class="search-result-item">
                  <a
                    (click)="navigateToSearchResultsLink(result)"
                    [core-analytics]="{
                      action: 'Follow result',
                      category: 'SEARCH',
                    }"
                    class="search-result-item-heading"
                    href="javascript:void(0)"
                    >{{ result.name }}</a
                  >
                  @if (result.description) {
                    <p class="search-result-item-description">
                      {{ result.description }}
                    </p>
                  }
                </div>
              }
            </div>
          }
          @if (hasDocuments()) {
            <div class="documents-container-wrapper">
              <div class="documents-container">
                <h4>Documents</h4>
                @for (result of documentResults; track 'doc-' + $index) {
                  <div class="search-result-document-item">
                    <a
                      (click)="navigateToSearchResultsLink(result)"
                      [core-analytics]="{
                        action: 'Follow result',
                        category: 'SEARCH',
                      }"
                      class="search-result-document-heading"
                      href="javascript:void(0)"
                      >{{ result.name }}</a
                    >
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
